// extracted by mini-css-extract-plugin
export default {"shadow":"Button3d_shadow__6-pnv","edge":"Button3d_edge__-eniC","front":"Button3d_front__JGn-W","text":"Button3d_text__OzgQl"};